import React from 'react';

import { Toolbar, ToolButton } from '@ergeon/core-components';
import { ChatBubbleLeftRightIcon, EnvelopeIcon, ClipboardDocumentListIcon } from '@ergeon/icons/hero/micro';

import type { ComposeToolbarType } from './InputTypes/types';

type ComposeToolbarProps = {
  activeType: ComposeToolbarType;
  onTypeChange: (type: ComposeToolbarType) => void;
};

const ComposeToolbar: React.FC<ComposeToolbarProps> = ({ activeType, onTypeChange }) => {
  const handleClick = (type: 'SMS' | 'Email' | 'Notes') => {
    // Toggle: if already active, deselect (set to null)
    onTypeChange(activeType === type ? null : type);
  };

  return (

    <Toolbar direction="row">
      <ToolButton
        checked={activeType === 'Notes'}
        hint="Notes"
        icon={<ClipboardDocumentListIcon className="size-5" />}
        onClick={() => handleClick('Notes')} />
      <ToolButton
        checked={activeType === 'SMS'}
        hint="SMS"
        icon={<ChatBubbleLeftRightIcon className="size-5" />}
        onClick={() => handleClick('SMS')} />
      <ToolButton
        checked={activeType === 'Email'}
        hint="Email"
        icon={<EnvelopeIcon className="size-5" />}
        onClick={() => handleClick('Email')} />
    </Toolbar>

  );
};

export default ComposeToolbar;
